(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_common/banner-helpers/assets/javascripts/jackpots.js') >= 0) return;  svs.modules.push('/components/banner_common/banner-helpers/assets/javascripts/jackpots.js');

'use strict';

var currencyInMillions;
var productMapping;

function jackpots(_ref) {
  var product = _ref.product,
    getJackpot = _ref.getJackpot;
  if (product === 'rubbet') {
    var totalJackpotAmount = productMapping.getAllNumericIds().map(function (numericId) {
      return getJackpot(numericId);
    }).reduce(function (sum, _ref2) {
      var jackpotAmount = _ref2.jackpotAmount;
      return sum + jackpotAmount;
    }, 0);
    return {
      jackpotLabel: 'Totala toppvinster',
      jackpotAmountString: "ca ".concat(currencyInMillions(totalJackpotAmount), " milj kr")
    };
  }
  var _getJackpot = getJackpot(product),
    defaultJackpot = _getJackpot.defaultJackpot,
    jackpotAmountStringShort = _getJackpot.jackpotAmountStringShort,
    description = _getJackpot.description;
  return {
    jackpotLabel: defaultJackpot ? "".concat(description, " alltid minst") : "".concat(description, " just nu"),
    jackpotAmountString: jackpotAmountStringShort.replace('minst ', '')
  };
}
if (svs.isServer) {
  var trinidad = require('trinidad-core').core;
  currencyInMillions = trinidad.components.require('utils', 'format').api.CurrencyInMillions;
  productMapping = trinidad.components.require('numbergames', 'product-mapping').productMapping;
  module.exports = {
    jackpots: jackpots
  };
} else {
  currencyInMillions = svs.utils.format.CurrencyInMillions;
  productMapping = svs.numbergames.productMapping;
  svs.banner_common.banner_helpers.jackpots = jackpots;
}

 })(window);